import type { Reference } from '@netpurpose/types'
import type { Reference as BackendReference } from '../../generated/facts'

export const formatReference = (reference: Reference): BackendReference => ({
  source_id: reference.source?.id as number,
  ...(reference.pageNumber ? { page_num: reference.pageNumber } : {}),
  reference_id: reference.id,
})
